import React, { useState } from 'react';
import "../App.css";
import emailjs from '@emailjs/browser';
import 'bootstrap/dist/css/bootstrap.min.css';
import header from "../assests/images/carousel-1.jpg";
import Swal from 'sweetalert2';
import { Mail, MapPin, PhoneCall } from 'lucide-react';

emailjs.init('D8lmS3WG4QkNAxEg9');
const ContactUs = () => {
  const [formData, setFormData] = useState({
    from_name: '',
    from_email: '',
    from_mobile: '',
    from_date: '',
    from_time: '',
    from_subject: '',
    problem_description: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleBookingSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await emailjs.sendForm(
        'service_ye32bk3',
        'template_95fb228',
        event.target
      );

      Swal.fire({
        title: 'Success!',
        text: 'Appointment booked successfully!',
        icon: 'success',
        confirmButtonColor: '#024A59',
        customClass: { confirmButton: 'swal-confirm-button' }
      });

      setFormData({
        from_name: '',
        from_email: '',
        from_mobile: '',
        from_date: '',
        from_time: '',
        from_subject: '',
        problem_description: '',
      });
    } catch (error) {
      console.error('EmailJS Error:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to send email. Please try again later.',
        icon: 'error',
        confirmButtonColor: '#024A59'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div
        className="container-fluid page-header py-1 mb-2 wow fadeIn justify-content-center text-center"
        data-wow-delay="0.1s"
        style={{
          backgroundImage: `url(${header})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "200px",
        }}
      >
        <div className="container py-2">
          <h1
            className="display-5 mb-2 animated slideInDown"
            style={{ color: '#FFA916', fontWeight: "bolder" }}
          >
            Contact Us
          </h1>
          <nav
            aria-label="breadcrumb"
            className="animated slideInDown"
          >
            <ol className="breadcrumb text-uppercase mb-0 justify-content-center text-center">
              <li className="breadcrumb-item">
                <a href="/" style={{ color: '#FFA916', fontWeight: "bold" }}>
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <p href="#" style={{ color: '#FFA916' }}>
                  Pages
                </p>
              </li>
              <li
                className="breadcrumb-item  active"
                aria-current="page"
                style={{ color: '#024A59', fontWeight: "bold" }}
              >
                Contact Us
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Appointment Section Start */}
      <div className="container-xxl py-2">
        <div className="container">
          <div className="row g-5">
            {/* Appointment Description */}
            <div
              className="col-lg-6"
              style={{
                animation: 'slideInLeft 2s ease-in-out',
                animationFillMode: 'both',
              }}
            >
              <h1 style={{ color: 'black', fontSize: '1.9rem' }} className="mb-6">
                Schedule Your Visit or Book a Demo
              </h1>

              <p style={{ color: 'black' }} className="mb-4">

                Experience our services first-hand by visiting our company or booking a demo.<br></br>
                Meet our experienced team, discuss your unique needs, and explore our tailored solutions in a welcoming environment.<br></br>
                Book your appointment today!
              </p>
            </div>
            {/* Appointment Form */}
            <div
              className="col-lg-6"
              style={{
                animation: 'slideInRight 1s ease-in-out',
                animationFillMode: 'both',
              }}
            >
              <div
                className="rounded h-100 d-flex align-items-center p-5"
                style={{ backgroundColor: '#024A59' }}
              >
                <form onSubmit={handleBookingSubmit}>
                  <div className="row g-3">
                    <div className="col-12 col-sm-6">
                      <input
                        style={{ color: 'black' }}
                        type="text"
                        name="from_name"
                        className="form-control border-0"
                        placeholder="Enter Your Name"
                        value={formData.from_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        style={{ color: 'black' }}
                        type="email"
                        name="from_email"
                        className="form-control border-0"
                        placeholder="Enter Your Email"
                        value={formData.from_email}
                        onChange={handleChange}
                        required
                        pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                        title="Please enter a valid email address (e.g., user@example.com)"
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                    <input
                      style={{ color: 'black' }}
                      type="tel"
                      name="from_mobile"
                      className="form-control border-0"
                      placeholder="Enter Your Mobile Number"
                      value={formData.from_mobile}
                      onChange={handleChange}
                      pattern="^\d{10}$"
                      title="Mobile number must be 10 digits"
                      required
                    />

                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        style={{ color: 'black' }}
                        type="date"
                        name="from_date"
                        className="form-control border-0"
                        value={formData.from_date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        style={{ color: 'black' }}
                        type="time"
                        name="from_time"
                        className="form-control border-0"
                        value={formData.from_time}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input
                        style={{ color: 'black' }}
                        type="subject"
                        name="from_subject"
                        className="form-control border-0"
                        placeholder='Subject'
                        value={formData.from_subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="col-12">
                      <textarea
                        style={{ color: 'black' }}
                        name="problem_description"
                        className="form-control border-0"
                        rows="5"
                        placeholder="Description"
                        value={formData.problem_description}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{ backgroundColor: '#FFA916', color: '#024A59' }}
                        className="btn w-100 py-3"
                      >
                        {isSubmitting ? 'Sending...' : 'Book Appointment'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
    @keyframes slideInLeft {
      from {
        transform: translateX(-100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
         .swal-confirm-button {
        background-color: #FFA916 !important;
        color: #024A59 !important;
        border: none !important;
      }
      .swal-title {
        color: #024A59 !important;
      }
      .swal-text {
        color: #024A59 !important;
      }
  `}
      </style>
      <div className="container-xxxxl py-2">
        <div className="container">
          <div className="row g-4">
            {/* Contact Details */}
            <div className="col-lg-4">
              <div className="h-100 rounded d-flex align-items-center p-5" style={{ backgroundColor: '#024A59' }}>
                <div className="d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle bg-white" style={{ width: '55px', height: '55px' }}>
                  {/* <i className="fa fa-map-marker-alt" style={{ color: '#FFA916' }}></i> */}
                  <MapPin style={{ color: 'FFA16' }} />
                </div>
                <div className="ms-4">
                  <p className="mb-2" style={{ color: '#FFA916' }}>
                    Address
                  </p>
                  <h5 className="mb-0" style={{ color: 'white' }}>
                    Ngong, Uptown Mall
                  </h5>
                  <h5 className="mb-0" style={{ color: 'white' }}>
                    Nairobi, Kenya
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="h-100 rounded d-flex align-items-center p-5" style={{ backgroundColor: '#024A59' }}>
                <div className="d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle bg-white" style={{ width: '55px', height: '55px' }}>
                  {/* <i className="fa fa-phone-alt" style={{ color: '#FFA916' }}></i> */}
                  <PhoneCall style={{ color: 'FFA16' }} />
                </div>
                <div className="ms-4">
                  <p className="mb-2" style={{ color: '#FFA916' }}>
                    Call Us Now
                  </p>
                  <h5 style={{ color: 'white' }}>
                    <a href="https://wa.me/254796265933" style={{ color: 'inherit' }}>+254 796 265933</a><br />
                    <a href="https://wa.me/254728813009" style={{ color: 'inherit' }}>+254 728 813009</a>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="h-100 rounded d-flex align-items-center p-5" style={{ backgroundColor: '#024A59' }}>
                <div className="d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle bg-white" style={{ width: '55px', height: '55px' }}>
                  {/* <i className="fa fa-envelope-open" style={{ color: '#FFA916' }}></i> */}
                  <Mail style={{ color: 'FFA16' }} />
                </div>
                <div className="ms-4">
                  <p className="mb-2" style={{ color: '#FFA916' }}>
                    Mail Us Now
                  </p>
                  <h5 style={{ color: 'white' }}>
                    <a href="mailto:info@statify.co.ke" style={{ color: 'inherit' }}>info@statify.co.ke</a>
                  </h5>
                </div>
              </div>
            </div>

            {/* Map Section */}
            <div className="col-12" style={{ position: 'relative', height: '60vh', overflow: 'hidden' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.9818265242175!2d36.654182!3d-1.3502966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f037eb4e3c86b%3A0xebe7ae25b6b1fa05!2sUptown%20Mall%2C%20Ngong!5e0!3m2!1sen!2ske!4v1699261116928!5m2!1sen!2ske"
                style={{
                  position: 'relative',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '95%',
                  border: 0,
                }}
                allowFullScreen
                loading="lazy"
                title="Uptown Mall Location Map"
                aria-label="Google Maps showing Uptown Mall location"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Contact Section End */}
    </div>
  );
};

export default ContactUs;

